module.exports = __webpack_public_path__ + "static/interview-dd86ec468fd0adf30f19a95ab71e4a39.jpg";